import React,{useState,useEffect,useContext} from 'react'
import {Dashboard,Election,Education,Nomination,Vpat,Choose} from './'
import { Link, useNavigate,Navigate } from 'react-router-dom';
import {FaBars,FaTimes} from 'react-icons/fa'
import {BiSolidUser} from 'react-icons/bi'
import {menu,menu2} from '../sampleData'
import { UserProvider } from '../contexts/userContext';


const AppPage = () => {
    const navigate = useNavigate()

    const [open,setOpen] = useState(false)
    const [open2,setOpen2] = useState(false)
    const [popper,setPopper] = useState(false)
    const [active,setActive] = useState(menu[0].name)
    const handleClick = () => {
    setOpen((prev) => !prev)
    }
    
        return (
            <div
            className='h-screen bg-light text-dark relative'
            >
            {/* Header */}
            <header
            className='bg-light flex items-center justify-between px-3 py-1 shadow-sm shadow-dark relative'
            >
            {/* Logo */}
            <div>
            <img
            className='w-8 h-8'
            onClick={() => setActive(menu[0].name)}
            src='myKura.png'
            alt='Logo'
            />
            </div>
        
            {/* Menu */}
            <div
            className='flex items-center space-x-2'
            >
            <BiSolidUser 
            onClick={() => setPopper((prev) => !prev)}
            className='cursor-pointer hover:bg-dark/40'/>
        
            {popper && (
            <div className='bg-purple p-6 absolute top-10 right-1 text-white'>
            <Link to='/sign-in'>Sign Out</Link>
            </div>
            )}
            {open ?
            <FaTimes 
            onClick={handleClick}
            className='cursor-pointer hover:bg-dark/40 sm:hidden' />
            :
            <FaBars 
            onClick={handleClick}
            className='cursor-pointer hover:bg-dark/40 sm:hidden'/>
            }
            </div>
            </header>
        
            {/* Sidebar */}
            {/* Login Menu */}
            <aside 
            className={`${open ? 'flex' : 'hidden'} absolute top-12 right-1 w-[150px] bg-purple text-light px-2 py-4 text-sm z-99 `}
            >
            <div className='grid gap-5'>
            {menu.map((d,i) => (
            <p
            onClick = {() => {
            setActive(d.name)
            setOpen(false)
            }}
            className={`${d.name === active ? 'text-blue' : 'text-light'} cursor-pointer`}
            >
            {d.name}
            </p>
            ))}
            </div>
            </aside>
            {/* Sidebar mobile */}
            <aside 
            className={`hidden absolute top-12 right-1 w-[150px] bg-purple text-light h-full px-2 py-1 text-sm z-99 sm:hidden`}
            >
            <div className='grid gap-5'>
            {menu2.map((d,i) => (
            <Link 
            key={i}
            to={d.href}
            className={` cursor-pointer`}
            >
            {d.name}
            </Link>
            ))}
            </div>
            </aside>
            <div className='flex'>
            {/* Sidebar wide */}
            <aside 
            className={`hidden sm:flex w-[300px] bg-purple text-light screen px-2 py-1 text-sm flex-col items-center justify-center`}
            >
            <div className='grid gap-5'>
            {menu.map((d,i) => (
            <p
            onClick = {() => {
            setActive(d.name)
            setOpen(false)
            }}
            className={`${d.name === active ? 'text-blue' : 'text-light'} cursor-pointer`}
            >
            {d.name}
            </p>
            ))}
            </div>
            </aside>
        
            {/* Pages,views aka routes */}
            <div className='h-full w-full'>
            {active === 'Home' && <Dashboard/>}
            {active === 'Elections' && <Election/>}
            {active === 'Voter Education' && <Education/>}
            {active === 'Nomination' && <Nomination/>}
            {active === 'VvPat' && <Vpat/>}
            {active === 'Choose' && <Choose/>}
            </div>
            </div>
        
            </div>
          )
    }

export default AppPage